// import React, { useState } from "react";
// import {
//   Drawer,
//   Box,
//   Divider,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Tooltip,
//   Avatar,
//   alpha,
//   Badge,
//   Paper,
//   Zoom,
//   Collapse,
//   useTheme
// } from "@mui/material";
// import {
//   getValue,
//   IsSmallScreen,
//   LoacalVariables
// } from "../../commonFunctions/CommonFunctions";
// import { getMenu } from "./menu";
// // import SettingsIcon from "@mui/icons-material/Settings";
// import LogoutIcon from "@mui/icons-material/Logout";
// import { Link, useLocation } from "react-router-dom";
// import logo from '../../images/melp-logo-2.svg'
// import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import { useAuth } from "../../Context/AuthContext";

// interface MenuItem {
//   id: number;
//   label: string;
//   path?: string;
//   icon: React.ElementType;
//   children?: MenuItem[];
// }

// interface SidebarProps {
//   open: boolean;
//   handleDrawerToggle: () => void;
//   handleCollapse: () => void;
//   collapse: boolean;
//   drawerWidth?: number;

//   primaryColor: string;
//   secondaryColor: string;
//   hoverColor: string;
//   textColor: string;
//   iconColor: string;
//   hoverTextColor: string;
//   backgroundColor: string;
//   selectedBackgroundColor: string;
//   boxShadowColor: string;
// }

// const Sidebar2: React.FC<SidebarProps> = ({
//   open,
//   handleDrawerToggle,
//   collapse,
//   drawerWidth = 280,
//   textColor,
// }) => {
//   const theme = useTheme();
//   const isMobile = IsSmallScreen();
//   const location = useLocation(); // Get the current location from React Router

//   const { handleLogout } = useAuth();

//   const [hoveredMenuPosition, setHoveredMenuPosition] = useState({ top: 0 });

//   const userType: any = getValue(LoacalVariables.UserType);
//   const [openChildMenus, setOpenChildMenus] = useState<Record<number, boolean>>(
//     {}
//   );
//   const [selectedId, setSelectedId] = useState<number | null>(null);

//   const [hoveredMenuId, setHoveredMenuId] = useState<number | null>(null);

//   // Helper function to determine if the menu item is selected
//   const isSelected = (id: number, path?: string) =>
//     location.pathname === path && selectedId === id;


//   const menu = getMenu(userType);
//   const userName = getValue(LoacalVariables.Name)

//   const handleToggleChildMenu = (id: number) => {
//     setOpenChildMenus((prev) => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   const handleMouseEnter = (id: number) => {
//     setHoveredMenuId(id);

//     // Find the hovered list item position
//     const listItem = document.getElementById(`menu-item-${id}`);
//     if (listItem) {
//       const rect = listItem.getBoundingClientRect();
//       setHoveredMenuPosition({ top: rect.top + window.scrollY });
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoveredMenuId(null);
//   };

//   return (
//     <Drawer
//       variant="persistent"
//       anchor="left"
//       open={open}
//       onClose={handleDrawerToggle}
//       sx={{
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//           width: collapse ? 88 : drawerWidth,
//           overflowX: "hidden",
//           transition: theme.transitions.create(['width', 'box-shadow'], {
//             duration: theme.transitions.duration.shorter,
//             easing: theme.transitions.easing.easeInOut,
//           }),
//           border: "none",
//           borderRight: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           position: "fixed",
//           top: 64,
//           height: "calc(100vh - 64px)",
//           left: 0,
//           borderRadius: 0,
//           backgroundColor: theme.palette.background.default,
//           boxShadow: `4px 0 20px ${alpha(theme.palette.common.black, 0.05)}`,
//           backgroundImage: `linear-gradient(180deg, ${alpha(
//             theme.palette.primary.main,
//             0.02
//           )} 0%, transparent 100%)`,
//         },
//       }}
//     >
//       {}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: collapse ? "center" : "space-between",
//           padding: collapse ? "1rem 0" : "1.2rem 1.5rem",
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           minHeight: 80,
//         }}
//       >
//         {!collapse ? (
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

//             <Typography
//               sx={{
//                 fontWeight: 700,
//                 fontSize: "1.2rem",
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 color: "transparent",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               {userName || "Business Name"}
//             </Typography>
//           </Box>
//         ) : (
//           <Tooltip title="Toggle Sidebar" placement="right">
//             <Avatar
//               src={logo}
//               alt="logo"
//               variant="rounded"
//               sx={{
//                 width: 48,
//                 height: 48,
//                 borderRadius: 2,
//                 boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
//                 cursor: "pointer",
//                 transition: "transform 0.2s ease",
//                 "&:hover": {
//                   transform: "scale(1.05)",
//                 },
//               }}
//             />
//           </Tooltip>
//         )}
//       </Box>

//       {}
//       {!collapse && (
//         <Box sx={{ px: 2.5, py: 2 }}>
//           <Typography
//             variant="caption"
//             sx={{
//               fontWeight: 600,
//               textTransform: "uppercase",
//               letterSpacing: "0.5px",
//               color: alpha(textColor, 0.5),
//               fontSize: "0.7rem",
//             }}
//           >
//             Main Menu
//           </Typography>
//         </Box>
//       )}

//       <List sx={{ px: collapse ? 1 : 2, py: 1 }}>
//         {menu.staticMenu.map((item: any) => (
//           <React.Fragment key={item.id}>
//             {}
//             <Tooltip
//               title={collapse ? item.label : ""}
//               placement="right"
//               arrow
//               disableHoverListener={!collapse}
//             >
//               <ListItemButton
//                 component={Link}
//                 to={item.path || "#"}
//                 onClick={() => {
//                   setSelectedId(item.id);
//                   if (item.children) handleToggleChildMenu(item.id);
//                 }}
//                 onMouseEnter={() => handleMouseEnter(item.id)}
//                 onMouseLeave={handleMouseLeave}
//                 sx={{
//                   minHeight: 48,
//                   justifyContent: collapse ? "center" : "flex-start",
//                   px: collapse ? 1 : 2,
//                   py: 1.5,
//                   mb: 0.5,
//                   borderRadius: 3,
//                   position: "relative",
//                   overflow: "hidden",
//                   backgroundColor: isSelected(item.id, item.path)
//                     ? alpha(theme.palette.primary.main, 0.08)
//                     : "transparent",
//                   color: isSelected(item.id, item.path) ? theme.palette.primary.main : textColor,
//                   "&::before": {
//                     content: '""',
//                     position: "absolute",
//                     left: 0,
//                     top: 0,
//                     bottom: 0,
//                     width: 4,
//                     backgroundColor: theme.palette.primary.main,
//                     borderRadius: "0 4px 4px 0",
//                     transform: isSelected(item.id, item.path) ? "scaleY(1)" : "scaleY(0)",
//                     transition: "transform 0.2s ease",
//                   },
//                   "&:hover": {
//                     backgroundColor: alpha(theme.palette.primary.main, 0.12),
//                     "& .MuiListItemIcon-root": {
//                       color: theme.palette.primary.main,
//                       transform: "scale(1.1)",
//                     },
//                   },
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: collapse ? "auto" : 40,
//                     mr: collapse ? 0 : 2,
//                     color: isSelected(item.id, item.path) ? theme.palette.primary.main : alpha(textColor, 0.7),
//                     transition: "all 0.2s ease",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Badge
//                     color="error"
//                     variant="dot"
//                     invisible={!item.badge}
//                     sx={{
//                       "& .MuiBadge-badge": {
//                         right: -2,
//                         top: 2,
//                       },
//                     }}
//                   >
//                     <item.icon sx={{ fontSize: collapse ? 24 : 22 }} />
//                   </Badge>
//                 </ListItemIcon>

//                 {!collapse && (
//                   <>
//                     <ListItemText
//                       primary={item.label}
//                       sx={{
//                         "& .MuiTypography-root": {
//                           fontSize: "0.95rem",
//                           fontWeight: isSelected(item.id, item.path) ? 600 : 500,
//                         },
//                       }}
//                     />
//                     {item.children && (
//                       <ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
//                         {openChildMenus[item.id] ? (
//                           <ExpandLess sx={{ fontSize: 20, color: alpha(textColor, 0.7) }} />
//                         ) : (
//                           <ExpandMore sx={{ fontSize: 20, color: alpha(textColor, 0.7) }} />
//                         )}
//                       </ListItemIcon>
//                     )}
//                   </>
//                 )}
//               </ListItemButton>
//             </Tooltip>

//             {}
//             {item.children && collapse && hoveredMenuId === item.id && (
//               <Zoom in={true} style={{ transitionDelay: "0.1s" }}>
//                 <Paper
//                   elevation={8}
//                   sx={{
//                     position: "fixed",
//                     left: 88,
//                     top: hoveredMenuPosition.top,
//                     zIndex: 2000,
//                     minWidth: 200,
//                     borderRadius: 2,
//                     overflow: "hidden",
//                     boxShadow: `0 10px 40px ${alpha(theme.palette.common.black, 0.15)}`,
//                     border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                   }}
//                   onMouseEnter={() => setHoveredMenuId(item.id)}
//                   onMouseLeave={() => setHoveredMenuId(null)}
//                 >
//                   <Box sx={{ py: 1 }}>
//                     <Typography
//                       sx={{
//                         px: 2,
//                         py: 1,
//                         fontSize: "0.75rem",
//                         fontWeight: 600,
//                         textTransform: "uppercase",
//                         color: alpha(textColor, 0.5),
//                         letterSpacing: "0.5px",
//                       }}
//                     >
//                       {item.label}
//                     </Typography>
//                     {item.children.map((child: any) => (
//                       <ListItemButton
//                         key={child.id}
//                         component={Link}
//                         to={child.path || "#"}
//                         onClick={() => setSelectedId(child.id)}
//                         sx={{
//                           px: 2,
//                           py: 1.5,
//                           transition: "all 0.2s ease",
//                           backgroundColor: isSelected(child.id, child.path)
//                             ? alpha(theme.palette.primary.main, 0.08)
//                             : "transparent",
//                           color: isSelected(child.id, child.path) ? theme.palette.primary.main : textColor,
//                           "&:hover": {
//                             backgroundColor: alpha(theme.palette.primary.main, 0.12),
//                             pl: 3,
//                           },
//                         }}
//                       >
//                         <ListItemText
//                           primary={child.label}
//                           sx={{
//                             "& .MuiTypography-root": {
//                               fontSize: "0.9rem",
//                               fontWeight: isSelected(child.id, child.path) ? 600 : 400,
//                             },
//                           }}
//                         />
//                       </ListItemButton>
//                     ))}
//                   </Box>
//                 </Paper>
//               </Zoom>
//             )}

//             {}
//             {item.children && !collapse && (
//               <Collapse in={openChildMenus[item.id]} timeout="auto" unmountOnExit>
//                 <List component="div" disablePadding>
//                   {item.children.map((child: any) => (
//                     <Tooltip
//                       key={child.id}
//                       title={collapse ? child.label : ""}
//                       placement="right"
//                       arrow
//                     >
//                       <ListItemButton
//                         component={Link}
//                         to={child.path || "#"}
//                         onClick={() => setSelectedId(child.id)}
//                         sx={{
//                           pl: 7,
//                           py: 1,
//                           mb: 0.5,
//                           borderRadius: 2,
//                           backgroundColor: isSelected(child.id, child.path)
//                             ? alpha(theme.palette.primary.main, 0.08)
//                             : "transparent",
//                           color: isSelected(child.id, child.path) ? theme.palette.primary.main : textColor,
//                           "&:hover": {
//                             backgroundColor: alpha(theme.palette.primary.main, 0.12),
//                           },
//                         }}
//                       >
//                         <ListItemText
//                           primary={child.label}
//                           sx={{
//                             "& .MuiTypography-root": {
//                               fontSize: "0.85rem",
//                               fontWeight: isSelected(child.id, child.path) ? 600 : 400,
//                             },
//                           }}
//                         />
//                       </ListItemButton>
//                     </Tooltip>
//                   ))}
//                 </List>
//               </Collapse>
//             )}
//           </React.Fragment>
//         ))}
//       </List>

//       {}
//       <Box sx={{ flexGrow: 1 }} />

//       <Divider sx={{ mx: 2, my: 2, opacity: 0.5 }} />

//       <List sx={{ px: collapse ? 1 : 2, pb: 2 }}>
//         {}
//         {}

//         {}
//         <Tooltip title={collapse ? "Logout" : ""} placement="right" arrow>
//           <ListItemButton
//             sx={{
//               minHeight: 48,
//               justifyContent: collapse ? "center" : "flex-start",
//               px: collapse ? 1 : 2,
//               py: 1.5,
//               borderRadius: 3,
//               color: alpha(theme.palette.error.main, 0.8),
//               "&:hover": {
//                 backgroundColor: alpha(theme.palette.error.main, 0.08),
//                 color: theme.palette.error.main,
//               },
//             }}
//             onClick={handleLogout}
//           >
//             <ListItemIcon
//               sx={{
//                 minWidth: collapse ? "auto" : 40,
//                 mr: collapse ? 0 : 2,
//                 color: "inherit",
//                 justifyContent: "center",
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: collapse ? 24 : 22 }} />
//             </ListItemIcon>
//             {!collapse && <ListItemText primary="Logout" />}
//           </ListItemButton>
//         </Tooltip>
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar2;





// import React, { useState } from "react";
// import {Drawer,Box,Divider,List,ListItemButton,ListItemIcon,ListItemText,Typography,Tooltip,Avatar,alpha,Badge,Paper,Zoom,Collapse,useTheme
// } from "@mui/material";
// import {
//   getValue,
//   IsSmallScreen,
//   LoacalVariables
// } from "../../commonFunctions/CommonFunctions";
// import MenuIcon from "@mui/icons-material/Menu";
// import { getMenu } from "./menu";
// // import SettingsIcon from "@mui/icons-material/Settings";
// import LogoutIcon from "@mui/icons-material/Logout";
// import { Link, useLocation } from "react-router-dom";
// import logo from '../../images/inventory_logo.png'
// import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import { useAuth } from "../../Context/AuthContext";

// interface MenuItem {
//   id: number;
//   label: string;
//   path?: string;
//   icon: React.ElementType;
//   children?: MenuItem[];
// }

// interface SidebarProps {
//   open: boolean;
//   handleDrawerToggle: () => void;
//   handleCollapse: () => void;
//   collapse: boolean;
//   drawerWidth?: number;
//   primaryColor: string;
//   secondaryColor: string;
//   hoverColor: string;
//   textColor: string;
//   iconColor: string;
//   hoverTextColor: string;
//   backgroundColor: string;
//   selectedBackgroundColor: string;
//   boxShadowColor: string;
// }

// const Sidebar2: React.FC<SidebarProps> = ({
//   open,
//   handleDrawerToggle,
//   handleCollapse,
//   collapse,
//   drawerWidth = 280,
//   textColor,
// }) => {
//   const theme = useTheme();
//   const isMobile = IsSmallScreen();
//   const location = useLocation(); // Get the current location from React Router

//   const { handleLogout } = useAuth();

//   const [hoveredMenuPosition, setHoveredMenuPosition] = useState({ top: 0 });

//   const userType: any = getValue(LoacalVariables.UserType);
//   const [openChildMenus, setOpenChildMenus] = useState<Record<number, boolean>>(
//     {}
//   );
//   const [selectedId, setSelectedId] = useState<number | null>(null);

//   const [hoveredMenuId, setHoveredMenuId] = useState<number | null>(null);

//   // Helper function to determine if the menu item is selected
//   const isSelected = (id: number, path?: string) =>
//     location.pathname === path && selectedId === id;

//   const menu = getMenu(userType);
//   const userName = getValue(LoacalVariables.Name)

//   const handleToggleChildMenu = (id: number) => {
//     setOpenChildMenus((prev) => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   const handleMouseEnter = (id: number) => {
//     setHoveredMenuId(id);

//     // Find the hovered list item position
//     const listItem = document.getElementById(`menu-item-${id}`);
//     if (listItem) {
//       const rect = listItem.getBoundingClientRect();
//       setHoveredMenuPosition({ top: rect.top + window.scrollY });
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoveredMenuId(null);
//   };

//   // Dynamic theme colors from your lightTheme
//   const sidebarTheme = {
//     primary: theme.palette.primary.main || "#C6FF00",
//     primaryLight: theme.palette.primary.light || "#E6FF66",
//     primaryDark: theme.palette.primary.dark || "#A6E600",
//     secondary: theme.palette.secondary.main || "#1F1F23",
//     secondaryLight: theme.palette.secondary.light || "#2A2A2E",
//     secondaryDark: theme.palette.secondary.dark || "#151518",
//     textPrimary: theme.palette.text.primary || "#111827",
//     textSecondary: theme.palette.text.secondary || "#6B7280",
//     backgroundDefault: theme.palette.background.default || "#F4F6F8",
//     error: theme.palette.error.main || "#EF4444",
//   };

//   return (
//     <Drawer
//       variant="persistent"
//       anchor="left"
//       open={open}
//       onClose={handleDrawerToggle}
//       sx={{
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//   width: collapse ? 88 : drawerWidth,
//   overflowX: "hidden",
//   border: "none",
//   position: "fixed",
//   top: 0,
//   left: 0,
//   height: "100vh",
//   background: "#1f1f23",
//   zIndex: 1100   // important
// },
//       }}
//     >

//       {}
//       <Box
//   sx={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: collapse ? "center" : "space-between",
//     padding: collapse ? "1rem 0" : "1rem 1.2rem",
//     borderBottom: `1px solid ${sidebarTheme.secondaryLight}`,
//     backgroundColor: sidebarTheme.secondary,
//     minHeight: 70,
//   }}
// >
//   {}
//   <Box
//   sx={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: collapse ? "center" : "space-between",
//     gap:9,
//     padding: collapse ? "1rem 0" : "1rem 1.2rem",
//     borderBottom: `1px solid ${sidebarTheme.secondaryLight}`,
//     backgroundColor: sidebarTheme.secondary,
//     minHeight: 70,
//   }}
// >
//   {}
//   {!collapse && (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 1,
//       }}
//     >
//       <Avatar
//         src={logo}
//         variant="rounded"
//         sx={{
//           width: 66,
//           height: 36,
//           borderRadius: 2,
//         }}
//       />
//     </Box>
//   )}

//   {}
//   <Box
//     onClick={handleCollapse}
//     sx={{
//       cursor: "pointer",
//       color: "#aaa",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       width: 36,
//       height: 36,
//       borderRadius: 2,
//       transition: "0.2s",
//       "&:hover": {
//         backgroundColor: alpha("#fff", 0.05),
//         color: sidebarTheme.primary,
//       },
//     }}
//   >
//     <MenuIcon />
//   </Box>
// </Box>

//   {}
//   {}
// </Box>

//       {}
//       {!collapse && (
//         <Box sx={{ px: 2.5, py: 2 }}>
//           <Typography
//             variant="caption"
//             sx={{
//               fontWeight: 600,
//               textTransform: "uppercase",
//               letterSpacing: "0.5px",
//               color: sidebarTheme.textSecondary,
//               fontSize: "0.7rem",
//             }}
//           >
//             Main Menu
//           </Typography>
//         </Box>
//       )}

//       <List sx={{ px: collapse ? 1 : 2, py: 1 }}>
//         {menu.staticMenu.map((item: any) => (
//           <React.Fragment key={item.id}>
//             {}
//             <Tooltip
//               title={collapse ? item.label : ""}
//               placement="right"
//               arrow
//               disableHoverListener={!collapse}
//             >
//               <ListItemButton
//                 id={`menu-item-${item.id}`}
//                 component={Link}
//                 to={item.path || "#"}
//                 onClick={() => {
//                   setSelectedId(item.id);
//                   if (item.children) handleToggleChildMenu(item.id);
//                 }}
//                 onMouseEnter={() => handleMouseEnter(item.id)}
//                 onMouseLeave={handleMouseLeave}
//                 sx={{
//   minHeight: 48,
//   justifyContent: collapse ? "center" : "flex-start",
//   px: collapse ? 1 : 2,
//   py: 1.5,
//   mb: 0.5,
//   borderRadius: 2,
//   position: "relative",
//   color: isSelected(item.id, item.path)
//     ? sidebarTheme.primary
//     : sidebarTheme.textSecondary,

//   // LEFT ACTIVE BAR
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     left: 0,
//     top: 6,
//     bottom: 6,
//     width: 4,
//     borderRadius: "0 4px 4px 0",
//     backgroundColor: sidebarTheme.primary,
//     opacity: isSelected(item.id, item.path) ? 1 : 0,
//     transition: "0.2s",
//   },

//   backgroundColor: isSelected(item.id, item.path)
//     ? alpha(sidebarTheme.primary, 0.08)
//     : "transparent",

//   "& .MuiTypography-root": {
//     fontWeight: isSelected(item.id, item.path) ? 600 : 500,
//   },

//   "& .MuiListItemIcon-root": {
//     color: isSelected(item.id, item.path)
//       ? sidebarTheme.primary
//       : sidebarTheme.textSecondary,
//   },

//   "&:hover": {
//     backgroundColor: sidebarTheme.secondaryLight,

//     "& .MuiListItemIcon-root": {
//       color: sidebarTheme.primary,
//     },
//   },
// }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: collapse ? "auto" : 40,
//                     mr: collapse ? 0 : 2,
//                     color: isSelected(item.id, item.path) ? sidebarTheme.primary : alpha(textColor, 0.7),
//                     transition: "all 0.2s ease",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Badge
//                     color="error"
//                     variant="dot"
//                     invisible={!item.badge}
//                     sx={{
//                       "& .MuiBadge-badge": {
//                         right: -2,
//                         top: 2,
//                       },
//                     }}
//                   >
//                     <item.icon sx={{ fontSize: collapse ? 24 : 22 }} />
//                   </Badge>
//                 </ListItemIcon>

//                 {!collapse && (
//                   <>
//                     <ListItemText
//                       primary={item.label}
//                       sx={{
//                         "& .MuiTypography-root": {
//                           fontSize: "0.95rem",
//                           fontWeight: isSelected(item.id, item.path) ? 600 : 500,
//                         },
//                       }}
//                     />
//                     {item.children && (
//                       <ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
//                         {openChildMenus[item.id] ? (
//                           <ExpandLess sx={{ fontSize: 20, color: alpha(textColor, 0.7) }} />
//                         ) : (
//                           <ExpandMore sx={{ fontSize: 20, color: alpha(textColor, 0.7) }} />
//                         )}
//                       </ListItemIcon>
//                     )}
//                   </>
//                 )}
//               </ListItemButton>
//             </Tooltip>

//             {}
//             {item.children && collapse && hoveredMenuId === item.id && (
//               <Zoom in={true} style={{ transitionDelay: "0.1s" }}>
//                 <Paper
//                   elevation={8}
//                   sx={{
//                     position: "fixed",
//                     left: 88,
//                     top: hoveredMenuPosition.top,
//                     zIndex: 2000,
//                     minWidth: 200,
//                     borderRadius: 2,
//                     overflow: "hidden",
//                     boxShadow: `0 10px 40px ${alpha(theme.palette.common.black, 0.15)}`,
//                     border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                   }}
//                   onMouseEnter={() => setHoveredMenuId(item.id)}
//                   onMouseLeave={() => setHoveredMenuId(null)}
//                 >
//                   <Box sx={{ py: 1 }}>
//                     <Typography
//                       sx={{
//                         px: 2,
//                         py: 1,
//                         fontSize: "0.75rem",
//                         fontWeight: 600,
//                         textTransform: "uppercase",
//                         color: alpha(textColor, 0.5),
//                         letterSpacing: "0.5px",
//                       }}
//                     >
//                       {item.label}
//                     </Typography>
//                     {item.children.map((child: any) => (
//                       <ListItemButton
//                         key={child.id}
//                         component={Link}
//                         to={child.path || "#"}
//                         onClick={() => setSelectedId(child.id)}
//                         sx={{
//                           px: 2,
//                           py: 1.5,
//                           transition: "all 0.2s ease",
//                           backgroundColor: isSelected(child.id, child.path)
//                             ? alpha(sidebarTheme.primary, 0.08)
//                             : "transparent",
//                           color: isSelected(child.id, child.path) ? sidebarTheme.primary : textColor,
//                           "&:hover": {
//                             backgroundColor: alpha(sidebarTheme.primary, 0.12),
//                             pl: 3,
//                           },
//                         }}
//                       >
//                         <ListItemText
//                           primary={child.label}
//                           sx={{
//                             "& .MuiTypography-root": {
//                               fontSize: "0.9rem",
//                               fontWeight: isSelected(child.id, child.path) ? 600 : 400,
//                             },
//                           }}
//                         />
//                       </ListItemButton>
//                     ))}
//                   </Box>
//                 </Paper>
//               </Zoom>
//             )}

//             {}
//             {item.children && !collapse && (
//               <Collapse in={openChildMenus[item.id]} timeout="auto" unmountOnExit>
//                 <List component="div" disablePadding>
//                   {item.children.map((child: any) => (
//                     <Tooltip
//                       key={child.id}
//                       title={collapse ? child.label : ""}
//                       placement="right"
//                       arrow
//                     >
//                       <ListItemButton
//                         component={Link}
//                         to={child.path || "#"}
//                         onClick={() => setSelectedId(child.id)}
//                         sx={{
//                           pl: 7,
//                           py: 1,
//                           mb: 0.5,
//                           borderRadius: 2,
//                           backgroundColor: isSelected(child.id, child.path)
//                             ? alpha(sidebarTheme.primary, 0.08)
//                             : "transparent",
//                           color: isSelected(child.id, child.path) ? sidebarTheme.primary : textColor,
//                           "&:hover": {
//                             backgroundColor: alpha(sidebarTheme.primary, 0.12),
//                           },
//                         }}
//                       >
//                         <ListItemText
//                           primary={child.label}
//                           sx={{
//                             "& .MuiTypography-root": {
//                               fontSize: "0.85rem",
//                               fontWeight: isSelected(child.id, child.path) ? 600 : 400,
//                             },
//                           }}
//                         />
//                       </ListItemButton>
//                     </Tooltip>
//                   ))}
//                 </List>
//               </Collapse>
//             )}
//           </React.Fragment>
//         ))}
//       </List>

//       {}
//       <Box sx={{ flexGrow: 1 }} />

//       <Divider sx={{ mx: 2, my: 2, opacity: 0.5 }} />

//       <List sx={{ px: collapse ? 1 : 2, pb: 2 }}>
//         {}
//         <Tooltip title={collapse ? "Logout" : ""} placement="right" arrow>
//           <ListItemButton
//             sx={{
//               minHeight: 48,
//               justifyContent: collapse ? "center" : "flex-start",
//               px: collapse ? 1 : 2,
//               py: 1.5,
//               borderRadius: 3,
//               color: alpha(sidebarTheme.error, 0.8),
//               "&:hover": {
//                 backgroundColor: alpha(sidebarTheme.error, 0.08),
//                 color: sidebarTheme.error,
//               },
//             }}
//             onClick={handleLogout}
//           >
//             <ListItemIcon
//               sx={{
//                 minWidth: collapse ? "auto" : 40,
//                 mr: collapse ? 0 : 2,
//                 color: "inherit",
//                 justifyContent: "center",
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: collapse ? 24 : 22 }} />
//             </ListItemIcon>
//             {!collapse && <ListItemText primary="Logout" />}
//           </ListItemButton>
//         </Tooltip>
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar2;




import React, { useState } from "react";
import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { SvgIconComponent } from "@mui/icons-material";

import logo from "../../images/inventory_logo.png";
import { Avatar } from "@mui/material";

// ✅ IMPORT getMenu + your helpers
import { getMenu } from "./menu";
import {
  getValue,
  LoacalVariables,
} from "../../commonFunctions/CommonFunctions";

// ✅ TYPE
interface MenuItem {
  id: number;
  label: string;
  path?: string;
  icon?: SvgIconComponent; // optional
  children?: MenuItem[];
}

interface Props {
  open: boolean;
  collapse: boolean;
  handleCollapse: () => void;
  drawerWidth?: number;
}

const Sidebar: React.FC<Props> = ({
  open,
  collapse,
  handleCollapse,
  drawerWidth = 260,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ GET USER TYPE
  const userType: any = getValue(LoacalVariables.UserType);


  // ✅ GET MENU FROM menu.ts
  const { staticMenu } = getMenu(userType);

  const [openMenus, setOpenMenus] = useState<Record<number, boolean>>({});

  // Flyout state for collapsed sidebar
  const [flyoutAnchor, setFlyoutAnchor] = useState<HTMLElement | null>(null);
  const [flyoutItem, setFlyoutItem] = useState<MenuItem | null>(null);

  const closeFlyout = () => {
    setFlyoutAnchor(null);
    setFlyoutItem(null);
  };

  const [selectedMenuId, setSelectedMenuId] = useState<number | null>(() => {
    const matchesPath = (path: string) => {
      const basePath = '/' + path.split('/')[1];
      return location.pathname === path || location.pathname === basePath || location.pathname.startsWith(basePath + '/');
    };
    for (const item of staticMenu) {
      if (item.path && matchesPath(item.path)) return item.id;
      if (item.children?.some((c: MenuItem) => c.path && matchesPath(c.path))) return item.id;
    }
    return staticMenu[0]?.id ?? null;
  });

  const toggleMenu = (id: number) => {
    setOpenMenus((prev) => ({
      [id]: !prev[id],
    }));
  };

  // Paths that belong to a menu item but use a different URL prefix
  const relatedPathsMap: Record<string, string[]> = {
    "/stockentry/list": ["/stockin", "/stockout"],
  };

  const isActive = (path?: string) => {
    if (!path) return false;
    const basePath = '/' + path.split('/')[1];
    const related = relatedPathsMap[path] || [];
    return (
      location.pathname === path ||
      location.pathname === basePath ||
      location.pathname.startsWith(basePath + '/') ||
      related.some(rp => location.pathname === rp || location.pathname.startsWith(rp + '/'))
    );
  };


  return (
    <>
    <style>{`
      .sidebar-inner::-webkit-scrollbar { display: none !important; width: 0 !important; }
      .sidebar-inner { -ms-overflow-style: none !important; scrollbar-width: none !important; }
    `}</style>
    <Drawer
      variant="persistent"
      open={open}
      PaperProps={{
        sx: {
          width: collapse ? 80 : drawerWidth,
          background: "linear-gradient(180deg, #1f2128, #1a1c22)",
          color: "#fff",
          border: "none",
          transition: "width 0.3s",
          paddingTop: "10px",
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": { width: "0px", display: "none" },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            right: -20,
            width: 20,
            height: 20,
            background: "#f4f6f8",
            borderTopLeftRadius: "20px",
            zIndex: 1,
            pointerEvents: "none",
          },
        },
      }}
    >
      {}
      <Box className="sidebar-inner" sx={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", overflowX: "hidden" }}>
      {}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: collapse ? "center" : "space-between",
          px: 2,
          py: 1.5,
        }}
      >
        {!collapse && (
          <Avatar
            src={logo}
            variant="rounded"
            sx={{
              width: 80,   // 👈 important (matches image)
              height: 45,
              borderRadius: 1,
            }}
          />
        )}

        <IconButton
          onClick={handleCollapse}
          sx={{
            color: "#aaa",
            width: 36,
            height: 36,
            "&:hover": {
              background: "rgba(255,255,255,0.05)",
              color: theme.palette.primary.main, // neon green
            },
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      {}
      <List sx={{ px: 1, overflowY: "auto", overflowX: "hidden", flex: 1, scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
        {staticMenu.map((item: MenuItem) => {
          const Icon = item.icon; // ✅ FIXED ICON HANDLING

          const hasChildren = !!item.children?.length;
          const isLink = !collapse || !hasChildren;

          return (
            <React.Fragment key={item.id}>
              <ListItemButton
                {...(isLink ? { component: Link, to: item.path || "#" } : {})}
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  setSelectedMenuId(item.id);
                  if (collapse && hasChildren) {
                    setFlyoutAnchor(e.currentTarget);
                    setFlyoutItem(item);
                    return;
                  }
                  if (hasChildren) toggleMenu(item.id);
                }}
                sx={{
                  borderRadius: 2,
                  mb: 1, // 👈 more spacing
                  px: collapse ? 1 : 2,
                  py: 1.4,
                  justifyContent: collapse ? "center" : "flex-start",
                  position: "relative",

                  backgroundColor: selectedMenuId === item.id
                    ? "rgba(198,255,0,0.08)"
                    : "transparent",

                  "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: 8,
                    bottom: 8,
                    width: 5, // 👈 thicker line
                    borderRadius: "0 6px 6px 0",
                    background: theme.palette.primary.main,
                    opacity: selectedMenuId === item.id ? 1 : 0,
                  },

                  "&:hover": {
                    backgroundColor: theme.palette.info.dark,
                  },
                }}
              >
                {}
                <ListItemIcon
                  sx={{
                    minWidth: collapse ? "auto" : 42,
                    color: selectedMenuId === item.id ? theme.palette.primary.main : theme.palette.info.light,
                    justifyContent: "center",

                    "& svg": {
                      fontSize: 22, // 👈 match icon size
                    },
                  }}
                >
                  {Icon && <Icon />}
                </ListItemIcon>

                {}
                {!collapse && (
                  <ListItemText
                    primary={item.label}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: 15,
                        fontWeight: selectedMenuId === item.id ? 600 : 500,
                        letterSpacing: "0.3px",
                      },
                    }}
                  />
                )}

                {}
                {!collapse && item.children && (
                  <>
                    {openMenus[item.id] ? <ExpandLess /> : <ExpandMore />}
                  </>
                )}
              </ListItemButton>

              {}
              {item.children && !collapse && (
                <Collapse in={openMenus[item.id]}>
                  <List sx={{ pl: 4, mt: 0.5 }}>
                    {item.children.map((child: MenuItem) => {
                      const active = isActive(child.path);

                      return (
                        <ListItemButton
                          key={child.id}
                          component={Link}
                          to={child.path || "#"}
                          sx={{
                            py: 0.8,
                            px: 1,
                            mb: 0.5,
                            borderRadius: 1,

                            // ❌ remove background boxes
                            backgroundColor: "transparent",

                            // ✅ subtle hover (not heavy)
                            "&:hover": {
                              backgroundColor: "transparent",
                              "& .MuiTypography-root": {
                                color: theme.palette.primary.main,
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary={child.label}
                            sx={{
                              "& .MuiTypography-root": {
                                fontSize: 14,
                                fontWeight: active ? 600 : 400,

                                // ✅ neon active color
                                color: active
                                  ? theme.palette.primary.main
                                  : "#cfcfcf",

                                letterSpacing: "0.3px",
                              },
                            }}
                          />
                        </ListItemButton>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </List>
      </Box>{}
    </Drawer>
    {}
    <Popover
      open={Boolean(flyoutAnchor) && !!flyoutItem}
      anchorEl={flyoutAnchor}
      onClose={closeFlyout}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{
        sx: {
          ml: 1,
          minWidth: 220,
          background: "#1f2128",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.06)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
        },
      }}
    >
      {flyoutItem && (
        <Box sx={{ py: 1 }}>
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontSize: 12,
              fontWeight: 700,
              textTransform: "uppercase",
              color: "#9aa0a6",
              letterSpacing: "0.5px",
            }}
          >
            {flyoutItem.label}
          </Typography>
          <List disablePadding>
            {flyoutItem.children?.map((child) => {
              const active = isActive(child.path);
              return (
                <ListItemButton
                  key={child.id}
                  onClick={() => {
                    if (child.path) navigate(child.path);
                    closeFlyout();
                  }}
                  sx={{
                    px: 2,
                    py: 1,
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.06)",
                      "& .MuiTypography-root": {
                        color: theme.palette.primary.main,
                      },
                    },
                  }}
                >
                  <ListItemText
                    primary={child.label}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: 14,
                        fontWeight: active ? 600 : 400,
                        color: active ? theme.palette.primary.main : "#cfcfcf",
                      },
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      )}
    </Popover>
    </>
  );
};

export default Sidebar;